<script setup>
import Card from '@/Components/Card/Card.vue';
import RiskPill from '@/Pages/Common/RiskPill.vue';
import RiskLabel from '@/Pages/DomainScore/Partials/RiskLabel.vue';
import RatingSquareScore from '@/Pages/DomainScore/Partials/RatingSquareScore.vue';

defineProps({
  title: String,
  lookup: String,
  score: Object,
  pills: Object
});
</script>

<template>
  <Card class="bg-white-opacity z-10 hidden p-5! px-2! lg:block">
    <div class="flex flex-col items-center gap-4">
      <div class="font-bold">{{ title }}</div>
      <RatingSquareScore :score="score[lookup].score" />
      <RiskLabel class="text-sm" :score="score[lookup].score" />
      <div class="flex flex-wrap justify-center gap-1">
        <RiskPill
          v-for="(value, key) in pills"
          :key="key"
          :score="score.records[key].score"
          :tag="value"
        />
        <slot />
      </div>
    </div>
  </Card>
</template>
